// src/lib/httpError.ts

export function decodeHtmlEntities(input: string) {
  // client-safe decode; no-op on server
  if (typeof document === "undefined") return input;
  const txt = document.createElement("textarea");
  txt.innerHTML = input;
  return txt.value;
}

/**
 * Extract a user-friendly message from WP/Woo Store API error responses.
 * - prefers JSON { message }
 * - decodes HTML entities (&quot;)
 * - falls back to truncated raw text
 */
export async function getNiceErrorMessage(res: Response) {
  const raw = await res.text().catch(() => "");
  if (!raw) return `Request failed (${res.status})`;

  try {
    const json = JSON.parse(raw) as { message?: unknown; code?: unknown };
    if (typeof json.message === "string" && json.message.trim()) {
      return decodeHtmlEntities(json.message);
    }
    if (typeof json.code === "string" && json.code.trim()) {
      return `Request failed (${res.status}) [${json.code}]`;
    }
  } catch {
    // not JSON
  }

  return decodeHtmlEntities(raw).slice(0, 400);
}